import type { Sep } from '@/types/api/user/synthesis/synthesisPoleEmploi';

// Text to display for empty lists
export const emptyListText = 'general.empty.search.message_short';
// KEYWORD FOR GENERAL ERROR
export const generalError = 'general.error.alert';
// Email for support team
export const supportEmail = 'support@assessfirst.com';

// Mapping table AF URI char to be converted
export const mappingTableURI = {
  '%23': '•23', // #
  '%24': '•24', // $
  '%26': '•26', // &
  '%2C': '•2C', // ,
  '%2F': '•2F', // /
  '%3A': '•3A', // :
  '%3B': '•3B', // ;
  '%3D': '•3D', // =
  '%3F': '•3F', // ?
  '%5B': '•5B', // [
  '%5D': '•5D' // ]
};

// Excluded params key in URL encoding
export const notEncodedURLParams = ['order', 'fields', 'page', 'per_page', 'group', 'with_default', 'meta', 'help'];

// URLS

export const paths = {
  gaston_url: {
    managers: '/recruiter/managers',
    inviteManager: '/recruiter/managers/invite',
    sharedProfiles: '/manager/shared-candidates',
    talentMapper: '/recruiter/talent-mapper',
    mobility: '/recruiter/mobility',
    CFGroup: '/recruiter/competency-framework',
    integrations: '/recruiter/integrations',
    profile: '/recruiter/profile/synthesis'
  },
  personal_account_url: {
    profile: '/profile',
    settings: '/settings'
  },
  link: {
    help: {
      fr: 'https://help.assessfirst.com/fr',
      en: 'https://help.assessfirst.com/en'
    },
    browser_extension:
      'https://chromewebstore.google.com/detail/assessfirst-extension/oilkofdijmifganbafhdclaicdaapdgg?pli=1'
  }
};

// Blog card sourcing url used on default card
export const sourcingArticleURL = {
  fr: 'https://www.assessfirst.com/fr/sourcing-creer-des-rencontres-qui-ont-du-sens/',
  en: 'https://www.assessfirst.com/en/sourcing-create-meaningful-relations/'
};

export const FLEXIBLE_REMOTE_POLICY = 2;

export const BUTTON_BAR_HEIGHT = 61;

export const TABLE_ITEMS_PER_PAGE = 24;

// NETWORK INVITE
export const PERSONALISED_MESSAGES_MAX = 5; // CONST for the max number of messages saved

export const NEW_GROUP_DEFAULT_COLOR = '#FF2F92';

// minimum number of characters needed to launch an Elastic search
export const MIN_CHARS_SEARCH = 2;

// Max number of sourcing candidates to be selected for bulk invite
export const MAX_SOURCING_BULK_INVITES = 50;

export const MAX_ERRORS_BATCHES = 25;
// Contacts table
export const MAX_USERS_COPY_EMAIL = 500;

export const MAX_CHARS = {
  group_label: 50,
  skill_label: 100,
  skill_definition: 1000,
  voice_custom_question: 350,
  campaign_step_name: 25,
  campaign_label: 70,
  predictive_model_name: 70,
  message_title: 100,
  personalized_message: 5000,
  review_comment: 5000,
  hubspot_message: 1000,
  meeting_link: 2048
};
export const MIN_USERS_SELECTED_GLOBAL = 100;
export const MIN_USERS_TEAM_ANALYSIS = 2;
export const MAX_USERS_DOWNLOAD_PDF = 5;
export const AUTHORIZED_CHARS_GROUP_LABEL = `" '(),-./+&`;

export const A_PLAYER_SCORE_MINIMUM_VALUE = 70;

// Rtl locale for af
export const RTL_LOCALE = ['ar-SA'];

// STATIC DATA
export const STATIC_DATA_PATHS = {
  locales: 'locales.json',
  currencies: 'currencies.json',
  degrees: 'degrees.json',
  jobs_acronyms: 'jobs-acronyms.json',
  language_levels: 'language-levels.json',
  periods: 'periods.json',
  po_keys: 'po-keys.json',
  remote_policies: 'remote-policies.json',
  skill_recommendations: 'skill-recommendations.json',
  voice_questions: 'voice-questions.json',
  skill_levels: 'skill-levels.json',
  personality: 'personality.json'
};

// VOICE
export const MAX_LANGUAGES_PM = 5;
export const MAX_SKILLS_PM = 10;

// FRANCE TRAVAIL
export const seps: { [key in Sep]: string } = {
  P1_autonomy: 'pole_emploi.soft_skills.autonomy',
  P2_decision: 'pole_emploi.soft_skills.individual.decisions',
  P3_curiosity: 'pole_emploi.soft_skills.curiosity',
  P4_power: 'pole_emploi.soft_skills.proactivity',
  P5_persistence: 'pole_emploi.soft_skills.perseverance',
  P6_stepback: 'pole_emploi.soft_skills.individual.objectivity',
  P7_adaptation: 'pole_emploi.soft_skills.adaptability',
  P8_stress: 'pole_emploi.soft_skills.stress',
  P9_reactivity: 'pole_emploi.soft_skills.responsiveness',
  P10_rigor: 'pole_emploi.soft_skills.conscientiousness',
  P11_organization: 'pole_emploi.soft_skills.organization',
  P12_federate: 'pole_emploi.soft_skills.leadership',
  P13_communicate: 'pole_emploi.soft_skills.listening',
  P14_teamwork: 'pole_emploi.soft_skills.teamwork',
  P15_inspire: 'pole_emploi.soft_skills.inspire',
  P16_service: 'pole_emploi.soft_skills.service',
  P17_engagement: 'pole_emploi.soft_skills.engagement',
  P18_creativity: 'pole_emploi.soft_skills.creativity'
};

// BYTES PER MB FOR HUBSPOT
export const BYTES_PER_MB = 1048576;

// MAXIMUM NUMBER OF HIRING MANAGERS
export const MAX_HIRING_MANAGERS = 10;

export const PENDING_ACCOUNT_ID = 2;

// DURATION WORKFLOW PM STEPS
export const SCREENING_CRITERIA_DURATION = {
  basic: 0.5, // minutes (= 30s)
  complex: 2 // minutes (= 120s)
};
export const SWIPE_DURATION = 5;
export const DRIVE_DURATION = 10;
export const BRAIN_DURATION = 10;
export const VOICE_SKILL_LANGUAGE_DURATION = 2;

//WORKFLOW STEP
export const WORKFLOW_STEP = {
  SCREENING: 'screening',
  SOFT_SKILLS: 'softskills',
  HARD_SKILLS: 'hardskills',
  MEETING: 'meeting'
};
export const FALLBACK_GRADIENTS = ['#797979', '#D6D6D6'];

// TEAM ANALYSIS REASONS FOR INCOMPLETE EXPORT
export const INCOMPLETE_EXPORT_REASONS = {
  TOO_MANY_MEMBERS: 'too_many_members',
  NO_MANAGER: 'no_manager',
  INCOMPLETE_ASSESSMENTS: 'incomplete_assessments'
};

// COPILOT
export const MAX_CAREER_PATH_JOBS = 5;

export const EMAIL_REGEX = /^[\w-.+]+@([\w-]+\.)+[\w-]{2,15}$/;
